module.exports = __webpack_public_path__ + "static/media/nail.e7df0920.svg";